<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-3" d="m66.26,78.74H30.76c-4.9,0-8.88-3.98-8.88-8.88V21.2c0-5.48,4.46-9.94,9.94-9.94h34.43c1.03,0,1.86.83,1.86,1.86v63.77c0,1.03-.83,1.86-1.86,1.86ZM31.82,14.98c-3.43,0-6.22,2.79-6.22,6.22v48.67c0,2.84,2.31,5.16,5.16,5.16h33.63V14.98H31.82Z"/>
  <path class="cls-3" d="m66.26,78.74H30.97c-5.01,0-9.09-4.08-9.09-9.09,0-2.42.95-4.7,2.67-6.42,1.72-1.72,3.99-2.66,6.42-2.66h35.28c1.03,0,1.86.83,1.86,1.86v14.45c0,1.03-.83,1.86-1.86,1.86Zm-35.28-14.45c-1.43,0-2.77.56-3.79,1.58-1.02,1.02-1.58,2.36-1.58,3.79,0,2.96,2.41,5.37,5.37,5.37h33.42v-10.73H30.97Z"/>
  <path class="cls-3" d="m60.39,70.59h-30.78c-.51,0-.93-.42-.93-.93s.42-.93.93-.93h30.78c.51,0,.93.42.93.93s-.42.93-.93.93Z"/>
  <g>
    <path class="cls-1" d="m35.25,69.66v7.46c0,.18.21.27.34.14l2.75-2.7c.13-.13.33-.13.46,0l2.72,2.67c.14.13.37.04.37-.15v-7.43h-6.65Z"/>
    <path class="cls-2" d="m35.45,78.25c-.15,0-.3-.03-.44-.09-.42-.18-.69-.59-.69-1.04v-8.39h8.51v8.36c0,.46-.28.88-.7,1.06-.43.18-.91.08-1.25-.24l-2.3-2.26-2.33,2.29c-.22.21-.5.32-.79.32Zm6.73-1.68h0s0,0,0,0Zm-6-5.98v4.8l1.51-1.48c.49-.48,1.28-.48,1.77,0l1.51,1.48v-4.79h-4.78Z"/>
  </g>
  <path class="cls-4" d="m31.27,43.05c-.51,0-.93-.42-.93-.93v-23.12c0-.51.42-.93.93-.93s.93.42.93.93v23.12c0,.51-.42.93-.93.93Z"/>
  <path class="cls-4" d="m31.27,57.5c-.51,0-.93-.42-.93-.93v-8.89c0-.51.42-.93.93-.93s.93.42.93.93v8.89c0,.51-.42.93-.93.93Z"/>
  <path class="cls-2" d="m57.12,27.02h-18.77c-1.2,0-2.17-.97-2.17-2.17s.97-2.17,2.17-2.17h18.77c1.2,0,2.17.97,2.17,2.17s-.97,2.17-2.17,2.17Z"/>
  <path class="cls-2" d="m57.12,34.69h-18.77c-1.2,0-2.17-.97-2.17-2.17s.97-2.17,2.17-2.17h18.77c1.2,0,2.17.97,2.17,2.17s-.97,2.17-2.17,2.17Z"/>
</svg>
</template>

<script>
export default {
    name: "GlossaryIcon",
}
</script>

<style scoped>
.cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #115c72;
  }
  .cls-3 {
    fill: #59c5c7;
  }
  .cls-4 {
    fill: #bee2d3;
  }
</style>